import { baseApi } from "./baseApi";
import type { Trace, TraceEvent } from "../api";

interface TraceDetail {
  trace: Trace;
  events: TraceEvent[];
}

/**
 * Endpoints de Traces para RTK Query.
 *
 * Diseño:
 *   • La LISTA sigue manejándose en Traces.tsx con HTTP + WebSocket (snapshot
 *     + stream pattern). RTK Query no se usa para la lista porque el stream
 *     vivo lo provee el WS y duplicar el cache sería redundante.
 *
 *   • El DETALLE sí va por RTK Query. Apenas el usuario hace click en un row,
 *     se dispara el fetch y mientras tanto el panel muestra skeleton. Si el
 *     usuario vuelve a abrir el mismo trace después (típico en debugging),
 *     ya está cacheado y se ve al instante.
 */
export const tracesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTraceDetail: builder.query<TraceDetail, string>({
      query: (correlationId) => `/v1/traces/${correlationId}`,
      // El backend devuelve los events ya populated (request/response/metadata
      // completos) desde el cambio en traces.ex:59 — no hace falta lazy fetch
      // adicional por evento.
      providesTags: (_r, _e, correlationId) => [{ type: "Stats", id: `trace-${correlationId}` }],
      // Cache 5 minutos. Los traces ya cerrados (state=ok|error) son inmutables,
      // así que volver a abrirlos no necesita re-fetch. El stream WS sigue
      // alimentando la lista en vivo por su lado.
      keepUnusedDataFor: 300,
    }),
  }),
  overrideExisting: false,
});

export const { useGetTraceDetailQuery } = tracesApi;
